export enum ReviewRequestType {
  Approval,
  Acceptance,
  Unsupported
}
